import { render, staticRenderFns } from "./EssayPapers.vue?vue&type=template&id=63cd37e1&scoped=true&"
import script from "./EssayPapers.vue?vue&type=script&lang=js&"
export * from "./EssayPapers.vue?vue&type=script&lang=js&"
import style0 from "./EssayPapers.vue?vue&type=style&index=0&id=63cd37e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cd37e1",
  null
  
)

export default component.exports